import AdminPerformance from './container';

export default AdminPerformance;
